import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-white text-base md:text-xl xl:text-2xl font-semibold" }
const _hoisted_2 = { class: "card-content-row" }
const _hoisted_3 = { class: "card-content-row" }
const _hoisted_4 = { class: "card-content-row" }
const _hoisted_5 = { class: "card-content-row" }
const _hoisted_6 = { class: "card-content-row" }
const _hoisted_7 = { class: "card-content-row" }


import { CalendarDayParams } from "@/types/calculators";
import DayCardComponent from "@/views/Calculators/ChineseCalendar/components/DayCardComponent.vue";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'DayParamsCardComponent',
  props: {
    date: {},
    dayParams: {}
  },
  setup(__props: any) {



const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DayCardComponent, null, {
    "card-title": _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(t)("calculators.chinese-calendar-day.day-params.title")), 1)
    ]),
    "card-content": _withCtx(() => [
      _createElementVNode("p", _hoisted_2, [
        _createTextVNode(_toDisplayString(_unref(t)("calculators.chinese-calendar-day.day-params.date")) + " ", 1),
        _createElementVNode("span", null, _toDisplayString(new Date(__props.date).toLocaleDateString()), 1)
      ]),
      _createElementVNode("p", _hoisted_3, [
        _createTextVNode(_toDisplayString(_unref(t)("calculators.chinese-calendar-day.day-params.conform")) + " ", 1),
        _createElementVNode("span", null, _toDisplayString(__props.dayParams.conform), 1)
      ]),
      _createElementVNode("p", _hoisted_4, [
        _createTextVNode(_toDisplayString(_unref(t)("calculators.chinese-calendar-day.day-params.no-conform")) + " ", 1),
        _createElementVNode("span", null, _toDisplayString(__props.dayParams.no_conform), 1)
      ]),
      _createElementVNode("p", _hoisted_5, [
        _createTextVNode(_toDisplayString(_unref(t)("calculators.chinese-calendar-day.day-params.year")) + " ", 1),
        _createElementVNode("span", null, _toDisplayString(__props.dayParams.year_animal), 1)
      ]),
      _createElementVNode("p", _hoisted_6, [
        _createTextVNode(_toDisplayString(_unref(t)("calculators.chinese-calendar-day.day-params.month")) + " ", 1),
        _createElementVNode("span", null, _toDisplayString(__props.dayParams.month_animal), 1)
      ]),
      _createElementVNode("p", _hoisted_7, [
        _createTextVNode(_toDisplayString(_unref(t)("calculators.chinese-calendar-day.day-params.day")) + " ", 1),
        _createElementVNode("span", null, _toDisplayString(__props.dayParams.day_animal), 1)
      ])
    ]),
    _: 1
  }))
}
}

})